import { render, staticRenderFns } from "./SocialWallCommentForm.vue?vue&type=template&id=2cf51cb2&scoped=true"
import script from "./SocialWallCommentForm.vue?vue&type=script&lang=js"
export * from "./SocialWallCommentForm.vue?vue&type=script&lang=js"
import style0 from "./SocialWallCommentForm.vue?vue&type=style&index=0&id=2cf51cb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf51cb2",
  null
  
)

export default component.exports